import { IconElement } from 'types/IconElement';
import { memo } from 'react';
import classes from 'classnames';
import styles from './Title.module.scss';

export type TitleProps = {
  dataTest?: string;
  icon?: IconElement;
  text: string;
  mobileText?: string;
  forceColumn?: boolean;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  onTextClick?: () => void;
};

export default memo(function Title({
  dataTest = 'title',
  icon,
  text,
  mobileText = undefined,
  forceColumn = false,
  className,
  iconClassName,
  textClassName,
  onTextClick,
}: TitleProps) {
  return (
    <div
      className={classes(
        styles.container,
        className,

        forceColumn && styles['container-force-column'],
      )}
      data-test={dataTest}
    >
      {icon && (
        <div
          className={classes(
            styles.icon,
            forceColumn && styles['force-column'],
            iconClassName,
          )}
          data-test={`${dataTest}-icon-wrapper`}
        >
          {icon}
        </div>
      )}

      <div
        className={classes(
          styles.text,
          mobileText && styles['hide-on-mobile'],
          textClassName,
        )}
        dangerouslySetInnerHTML={{ __html: text }}
        onClick={onTextClick}
        data-test={`${dataTest}-text`}
      />

      {mobileText && (
        <div
          className={classes(styles.text, styles['hide-on-desktop'])}
          dangerouslySetInnerHTML={{ __html: mobileText }}
          data-test={`${dataTest}-mobile-text`}
          onClick={onTextClick}
        />
      )}
    </div>
  );
});
